import type { CatSubscription } from '../../types';

export const renderValue = (value?: string | number | null) => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return value;
};

export const getDislikesDisplay = (catSubscription: CatSubscription) => {
  if (catSubscription.dislikes && catSubscription.dislikes.trim() !== '') {
    return catSubscription.dislikes;
  }

  if (catSubscription.funnelData?.dislikes && catSubscription.funnelData.dislikes.length > 0) {
    return catSubscription.funnelData.dislikes.join(', ');
  }

  return '-';
};
